import ExitModal from "./ExitModal";

export default ExitModal;